import OrderStrategy from "./OrderStrategy";

export const DefineByExecutor = OrderStrategy(0, "edi.orders.add_order.order_lifecycle.shipment_date_strategy.select.0");
export const FromOrderDateToOrderExpires = OrderStrategy(1, "edi.orders.add_order.order_lifecycle.shipment_date_strategy.select.1");
export const FromOrderExpireDate = OrderStrategy(2, 'edi.orders.add_order.order_lifecycle.shipment_date_strategy.select.2');
